'use client';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { RenderComp } from '../core/render-comp.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { FormFieldContext } from './form.context.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var o, t, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(t = 0; t < i.length; t++)o = i[t], !(r.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var o, t, n = {}, i = Object.keys(e);
    for(t = 0; t < i.length; t++)o = i[t], r.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
const FormField = renderWithRef('FormField', null, (t, i)=>{
    var { children: c } = t, p = _object_without_properties(t, [
        "children"
    ]);
    let [l, m] = useState(void 0), [f, s] = useState(new Set()), [u, d] = useState(new Set());
    return jsx(FormFieldContext.Provider, {
        value: {
            inputId: l,
            setInputId: m,
            helperIds: f,
            setHelperIds: s,
            errorIds: u,
            setErrorIds: d
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: i,
            props: p,
            children: c
        })
    });
});

export { FormField };
